
import benefitsImageMobile from "../../Assets/AIOnDemand/automation-benefits-mobile.png";
import benefitsImage from "../../Assets/AIOnDemand/automation-benefits.png";
import stroke from "../../Assets/AIOnDemand/green-stroke.png";

const AutomationIntegration = () => {
    return (
        <section className="w-full bg-black py-3 lg:py-24 mb-3 lg:mb-10">
            <div className="max-w-[1300px] md:pt-16 py-7 md:pb-0 px-7 md:px-0 mx-auto flex flex-col">
                <div className="text-center text-white mx-auto lg:mb-5">
                    <p className="font-medium text-xl lg:text-[2.5rem] mb-3">
                        Enterprise AI Sales & Marketing Automations
                    </p>
                </div>
                <img src={benefitsImage} alt="automation benefits" className="hidden md:block my-16 w-auto max-h-[150px] object-contain" />
                <img src={benefitsImageMobile} alt="automation benefits" className="block md:hidden my-4 w-auto max-h-[150px] object-contain" />
                <div className="text-center text-white mx-auto mb-5 lg:mt-16 mt-5 gap-3 flex flex-col">
                    <p className="font-medium flex flex-col lg:flex-row items-center text-xl lg:text-[2.5rem] mb-3 w-fit mx-auto">
                        <span className="whitespace-nowrap">
                            Seamlessly Integrated into
                        </span>
                        <div className="flex w-full flex-col mt-auto ml-2 relative items-center justify-center ">
                            Your Business
                            <img src={stroke} alt="green swish" className="-bottom-4 lg:left-0 max-w-[10rem] mx-auto lg:max-w-[18rem] absolute left-[50%] -translate-x-[50%] lg:-translate-x-0" />
                        </div>

                    </p>
                    <p className="text-md lg:text-[1.5rem] font-light mt-3">
                        For measurable revenue growth, all without slowing you down or increasing headcount.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AutomationIntegration;
